import React, { useEffect } from "react"
import { useFormikContext } from "formik"

export default function MrfInsertOperation(props) {
  const form = useFormikContext()
  const { mrf_source_manual_input } = form.values
  useEffect(() => {
    if (
      mrf_source_manual_input === "mrf_source_1" ||
      mrf_source_manual_input === "mrf_source_2"
    ) {
      form.setFieldValue("mrf_insert_operation", "OVERWRITE")
    } else {
      form.setFieldValue("mrf_insert_operation", "APPEND")
    }
  }, [mrf_source_manual_input])

  return <div id={props.fieldname} style={{ display: "none" }} />
}
